import React from 'react';
import { useDynamicShareButtonPosition } from './useDynamicShareButtonPosition';

interface PWAInstallModalProps {
  open: boolean;
  mode: 'ios' | 'android' | null;
  onRemindLater: () => void;
  onDismiss: () => void;
  browserType?: 'safari' | 'chrome' | 'other';
  isStandaloneMode?: boolean;
  data: any;
}

const UpwardArrow = () => (
  <div
    style={{
      position: 'absolute',
      top: '-10px',
      right: '40px',
      width: '0',
      height: '0',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderBottom: '10px solid #ffffff',
      filter: 'drop-shadow(0 -2px 4px rgba(0, 0, 0, 0.1))',
    }}
  />
);

export default function PWAInstallModal({
  open,
  mode,
  onRemindLater,
  onDismiss,
  browserType = 'safari',
  isStandaloneMode = false,
  data,
}: PWAInstallModalProps) {
  const { position } = useDynamicShareButtonPosition();
  const { webAddToHomeScreen } = data;
  // CRITICAL: Never render modal in standalone mode
  if (isStandaloneMode) {
    return null;
  }

  if (!open || mode !== 'ios') {
    return null;
  }

  const modalStyle: React.CSSProperties = {
    position: 'fixed',
    top: position.top,
    right: position.right,
    background: '#ffffff',
    borderRadius: '12px',
    padding: '16px 20px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,
    maxWidth: '444px',
    width: 'auto',
    border: '1px solid #e5e7eb',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  return (
    <div
      style={modalStyle}
      role="dialog"
      aria-modal="true"
      aria-label={webAddToHomeScreen?.header}
    >
      <UpwardArrow />
      <div className="flex flex-1">
        <div className="flex-[0.2]">
          <img
            className="rounded-md cursor-pointer"
            src={require('./assets/images/rb_logo.png')}
            alt="rb-logo"
            width={48}
            height={48}
          />
        </div>
        <div className="flex flex-[0.75] flex-col gap-4">
          <span className="text-xl font-semibold text-black">
            {webAddToHomeScreen?.header}
          </span>
          <span className="text-xl text-black">
            {webAddToHomeScreen?.sub_header}
          </span>
          <span>
            {webAddToHomeScreen.steps
              .split('/n')
              .map((line: string, idx: number) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
          </span>
        </div>
        <div className="flex-[0.05]">
          <img
            className="rounded-md cursor-pointer"
            src={require('./assets/images/ic_close.png')}
            alt="close-button"
            width={24}
            height={24}
            onClick={onDismiss}
          />
        </div>
      </div>

      <div className="flex flex-1 max-h-12 mt-4 gap-4">
        <button
          className="flex flex-[0.5] bg-[#DA291C] text-white items-center justify-center max-h-12 h-12 rounded-md cursor-pointer"
          onClick={onRemindLater}
        >
          {webAddToHomeScreen?.ctaPrimary}
        </button>
        <button
          className="flex flex-[0.5] max-h-12 items-center justify-center h-12 border border-[#DA291C] rounded-md cursor-pointer"
          onClick={onDismiss}
        >
          <span className="text-[#DA291C]">
            {webAddToHomeScreen?.ctaSecondary}
          </span>
        </button>
      </div>
    </div>
  );
}
